module.exports = __webpack_public_path__ + "static/src/content/silks/sunlight.5fa4d83.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/silks/sunlight.png
// module id = fTDs
// module chunks = 0